var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M930 4464 c-231 -49 -432 -247 -485 -476 -14 -60 -15 -219 -13 -1370 l3 -1303 22 -77 c49 -171 112 -296 213 -421 139 -172 328 -292 568 -360 77 -22 78 -22 1272 -25 845 -2 1218 0 1275 8 385 54 727 344 849 720 52 158 51 143 51 985 0 781 0 791 -22 876 -93 366 -366 659 -713 768 -144 45 -218 51 -668 51 l-426 0 -241 239 c-254 251 -307 293 -446 345 -138 52 -192 56 -703 55 -363 0 -486 -4 -536 -15z m1114 -452 c58 -27 95 -58 238 -200 96 -94 188 -195 213 -232 53 -82 97 -123 158 -150 46 -20 60 -21 555 -20 568 0 564 1 710 -71 111 -54 211 -153 269 -265 76 -146 74 -116 73 -929 0 -398 -4 -746 -9 -772 -51 -269 -269 -473 -546 -513 -57 -8 -398 -10 -1200 -8 -1016 3 -1125 5 -1175 21 -180 55 -334 182 -408 337 -71 151 -67 63 -67 1440 l0 1245 22 40 c26 49 57 79 103 99 30 13 102 15 515 13 l480 -2 69 -33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectory);
export default __webpack_public_path__ + "static/media/directory.54d5b423fd9e238f519356498be6da47.svg";
export { ForwardRef as ReactComponent };